<template>
    <div id="app">
        <NavigationBar></NavigationBar>
        <router-view></router-view>
    </div>
</template>

<script>
    import axios from 'axios'
    import {AUTH_LOGOUT, AUTH_SUCCESS} from "./store/actions/auth";
    import NavigationBar from "./components/site/NavigationBar";
    import {APP_STATE_REQUEST} from "./store/actions/app";

    export default {
        name: 'app',
        components: {
            NavigationBar
        },
        created: function () {
            // Устанавливаем базовый Url
            let that = this;

            axios.defaults.baseURL = process.env.VUE_APP_SERVER_URL;
            axios.interceptors.response.use(undefined, function (error) {
                let response = error.response;
                if (response.status === 401 && response.config && !response.config.__isRetryRequest) {
                    // if you ever get an unauthorized, logout the user
                    that.$store.dispatch(AUTH_LOGOUT);
                    that.$router.push('/login');
                }

                return Promise.reject(error);
            });

            // Открпвляем запрос на получении информации о пользователе если мы авторизовны
            let token = localStorage.getItem('user-token');
            if (token) {
                this.$store.commit(AUTH_SUCCESS, token);

                this.$store.dispatch(APP_STATE_REQUEST);
            }
        }
    }
</script>

<style>
    #app {
        /*font-family: Helvetica, Arial, sans-serif;*/
        color: #2c3e50;
    }

    body > h1 {
        font-weight: 200;
    }

</style>
